export const uniquePropArray = (items, prop) =>
  Array.from(new Set(items.map((item) => item[prop])));
